import actionConsts from '../../constants/actions';

const initialState = {
    isTimerOn: false,
    firebaseConfig: {}
};

const timerDetails = (state = initialState, action = {}) => {
    switch (action.type) {
        case actionConsts.RECEIVE_INIT_DATA:
            return {
                ...state,
                firebaseConfig: action.payload.config
            }

        case actionConsts.START_TIMER:
            return {
                ...state,
                isTimerOn: true
            };

        case actionConsts.RESET_TIMER:
            return {
                ...state,
                isTimerOn: false
            };

        default:
            return state;
    }
};

export default timerDetails;


// WEBPACK FOOTER //
// /src/reducers/uiState/timerDetails.js